export default class FinishController {
  // @ngInject
  constructor($state, $stateParams) {
    this.state = $state;
    this.stateParams = $stateParams;

    // Set in set_env.txt, baked in at build time by webpack DefinePlugin.
    this.dashboardUrl = process.env.TAPLAUSE_DASHBOARD_URL + '/' + $stateParams.dashboardId;
    this.targetUrl = process.env.TAPLAUSE_FRONTEND_URL + '/' + $stateParams.targetId;
  }
}
